import React from "react";
import './Product.css';
import { useParams } from "react-router-dom";
import { ShareButton } from "../ShareButton";
import { SizeGuide } from "../SizeGuide";
import { FaStepBackward } from "react-icons/fa";
import { Breadcrumb } from "../Breadcrumb";
import { Spinner } from "../Spinner";
import { useSettings } from "../Context/SettingsContext";
import ReactPixel from 'react-facebook-pixel';

function Product({referenceP, onBack})
{
    const { reference } = useParams();
    const [productData, setProductData] = React.useState(null);
    const [images, setImages] = React.useState([]);
    const [selectedImage, setSelectedImage] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [categoryName, setCategoyName] = React.useState(null);
    const settings = useSettings();

    const defaultImage = "https://via.placeholder.com/500x500?text=...";
    const reference2 = React.useMemo(() => referenceP || reference, [referenceP, reference]);

    React.useEffect(() => {
      if(categoryName)
      {        
        ReactPixel.track('ViewContent', {
          content_ids: [productData.reference],
          content_type: 'product',
          content_name: productData.modelName,
          content_category: categoryName,
          value: productData.price,
          currency: 'COP'
         }
        );
      }
    },[categoryName])

    React.useEffect(() => {

      const fetchProductData = async () => {
        try 
        {
          setLoading(true);
          setError(null);

          const response = await fetch(`${settings.ApiUrl}/Stock/GetByReference/${reference2}`);

          if (!response.ok) {  
            setError('Error al cargar los datos de la API');          
          }
          else{

            const data = await response.json();
  
            // Filtrar imágenes no nulas
            const validImages = [
              data.imageUrl1,
              data.imageUrl2,
              data.imageUrl3,
              data.imageUrl4,
            ].filter((url) => url !== null);  

            const imagePairs = validImages.map((url) => {
              const thumbnailUrl = url.replace(/(\.\w+)$/, '_thumbnail$1');
              return { original: url, thumbnail: thumbnailUrl };
            });
  
            setProductData(data);
            setImages(validImages.length > 0 ? imagePairs : [{ original: defaultImage, thumbnail: defaultImage}]);
            setSelectedImage(validImages.length > 0 ? imagePairs[0]?.original : defaultImage);
            setCategoyName(data.categoryName);      

          }
        } 
        catch (err) 
        { 
          setError(err.message);  
          setProductData(null);
        } 
        finally 
        {
          setLoading(false);
        }
      };
  
      if (reference2) {

        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("s");

        (async () => {
          try {
            await fetch(`${settings.ApiUrl}/View/AddView`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                reference: reference2,
                source
              })
            });
          } catch (error) {
            console.error("Error al registrar la visita:", error);
          }
        })();
        
        fetchProductData();
      }

    },[reference2])

    if (loading) {
      return (
         <Spinner></Spinner>
      );
    }
  
    if (error) {
      return (
        <div className="error-message">          
          <p>Por favor, inténtalo de nuevo más tarde.</p>
        </div>
      );
    }

    return (
      <div className="product-container">        

        {onBack &&
        <div className="back-button-container">
          <button className="back-button" onClick={onBack}>
           <FaStepBackward size={15} style={{ marginRight: "3px", verticalAlign: "bottom" }} />
           Volver
          </button>
        </div> }
        
        <Breadcrumb categoryParent={productData.categoryParent} categoryName={productData.categoryName} categoryId={productData.categoryId} productName={productData.modelName} />

        <div className="gallery-container">
        
          <div className="main-image">
            <img src={selectedImage} alt="Selected" loading="eager" />
          </div>    
          
          <div className="thumbnail-container">
            {images.map((image, index) => (
              <img
                key={index}
                src={image.thumbnail}
                alt={`Thumbnail ${index + 1}`}
                className={`thumbnail ${image.original === selectedImage ? "active" : ""}`}
                onClick={() => setSelectedImage(image.original)}
                loading="lazy"
                decoding="async"
              />
            ))}
          </div>
        </div>

        <div className="product-details">
          <h2>{productData.modelName || "Modelo desconocido"}</h2>
          <h4>{productData.additionalTitle || "Sin título adicional"}</h4>          
          <p className="description">{productData.description || "Descripción no disponible."}</p>
          <p className="price">           
            {productData.price
              ? `$${productData.price.toLocaleString()}`
              : "Precio no disponible"}
          </p>
          
          <div className="sizes-container">
            <h3>Tallas en Stock:</h3>
            {productData.sizes && productData.sizes.length > 0 ? (
              <ul className="sizes-list">
                {productData.sizes.map((size, index) => (
                  <li key={index}>
                    <strong>{size.size}:</strong> {size.available} {size.available === 1 ? "unidad" : "unidades"}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="no-available">AGOTADO</p>
            )}
          </div>
          <ShareButton reference={reference2} />

          {productData.measurements && (
            <SizeGuide measurements={productData.measurements} />
          )}
        </div>
        
      </div>
      );

}

export { Product };